module.exports = __webpack_public_path__ + "img/banner02_zh-TW.10ab7d0f.jpg";